export const AboutUS = () => {
  const services = [
    {
      icon: '/homesecurity.jpeg',
      title: 'HOUSING PROTECTION',
      link: '/building-maintenance',
      desc: "Security agency's staff is a solidary team of professionals, united by a common cause, traditions, interests and goals.We have highly qualified specialists, former employees of different power structures, employees of the FSB and the military, which gives us the ability",
    },
    {
      icon: '/businesssecurity.jpeg',
      title: 'BUSINESS PROTECTION',
      link: '/building-maintenance',
      desc: "Members of our team usually have experience in protection not less than 2 years, higher or secondary education diploma, specialized courses' diploma, qualifications and the identity of the guard.Outplacing to our agency, all guards pass personal validation, professional.",
    },
    {
      icon: '/controlsystems.jpg',
      title: 'CONTROL SYSTEMS',
      link: '/building-maintenance',
      desc: 'The presence of a security guard is a visual deterrent that can ward off thieves or criminals.Our mission is constant care about the safety of our clients, providing them reliable protection and giving people a feeling of calmness.',
    },
  ];

  return (
    <>
      <div className="mt-[6rem] flex w-full justify-center py-[2.5rem] font-inter md:py-[4rem]">
        <div className="flex w-full max-w-[114rem] flex-col items-stretch justify-center gap-[4rem] px-[2rem]">
          {/* ===== HEADING ===== */}
          <div className="flex flex-col items-center text-center">
            <h1 className="pt-[4rem] text-[3.6rem] font-[600] leading-[4.65rem] text-white md:pt-[6rem] lg:pt-[10rem]">
              About Us
            </h1>
            <h1 className="mb-[2rem] mt-[2rem] max-w-[70rem] text-[1.8rem] font-[400] leading-[2.4rem] text-[#828FA0]">
              WHETHER YOU ARE AT HOME OR ON THE ROAD, IT’S NEVER BEEN EASIER TO KEEP YOUR FAMILY AND
              HOME SAFE AND SECURE.
            </h1>
          </div>{' '}
        </div>{' '}
      </div>
      <div className="mt-[3rem] flex w-full justify-center py-[4rem] font-inter md:mt-[4rem] lg:mt-[6rem]">
        <div className="flex w-full max-w-[114rem] flex-col items-stretch justify-center gap-[4rem] px-[2rem]">
          {/* ===== HEADING ===== */}

          {/* ===== SMALL SERVICES GRID ===== */}
          <div className="grid w-full grid-cols-1 gap-[2rem] sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3">
            {services.map((item, index) => (
              <div
                key={index}
                className="flex flex-col items-center justify-start gap-3 rounded-xl bg-[#011936] p-6 py-[3rem] text-center transition"
              >
                <img
                  src={item.icon}
                  alt={item.title}
                  className="aspect-[1.7] w-[70%] rounded-md object-cover"
                />
                <h3 className="py-[1rem] text-[1.8rem] font-[600] leading-[2.7rem] text-white">
                  {item.title}
                </h3>
                <p className="text-[1.6rem] font-[400] leading-[2.4rem] text-[#828FA0]">
                  {item.desc}
                </p>
                {/* <div
                  onClick={() => {
                    navigate(item.link);
                  }}
                  className="mt-[2rem] flex w-full cursor-pointer items-center justify-center gap-[1rem] text-[#0EC9AC]"
                >
                  <h1 className="text-[1.2rem] font-[600] leading-[100%]">READ MORE</h1>
                  <ArrowRight className="h-auto w-[1.6rem] text-[1.2rem]" />
                </div> */}
              </div>
            ))}
          </div>
        </div>
      </div>
      <section className="relative mt-[3rem] w-full overflow-hidden md:mt-[6rem] lg:mt-[10rem]">
        {/* --- IMAGE ON RIGHT EDGE --- */}
        <div className="inset-y-0 right-0 w-full rounded-md lg:absolute lg:w-[45vw]">
          <img
            src="/slider1.jpg"
            className="h-full w-full rounded-md object-cover"
            alt="constructor"
          />
        </div>

        {/* --- MAIN CONTENT MAX WIDTH --- */}
        <div className="relative mx-auto flex max-w-[116rem] px-[2rem]">
          {/* LEFT TEXT COLUMN (60rem) */}
          <div className="mt-[3rem] w-full pr-[2rem] lg:mt-0 lg:w-[60rem]">
            <h1 className="text-[2.6rem] font-[700] leading-[3.6rem] text-[#0EC9AC] lg:text-[3rem] lg:leading-[4rem]">
              Who We Are
            </h1>

            <h1 className="text-[2.4rem] font-[700] leading-[3.2rem] text-white lg:text-[3rem] lg:leading-[4rem]">
              Reliable security that protects you—anytime, anywhere.
            </h1>

            <p className="mt-[2rem] text-[1.6rem] leading-[2.6rem] text-[#999]">
              Certified Security works with you to custom design a system to meet your individual
              needs and budget. We provide everything you need from a basic burglar and fire alarm
              to sophisticated “all-in-one” system. Take advantage of monitoring your home remotely.
              <br /> <br />
              Under the security systems we understand both physical protection, and special
              technical means by which is made a transfer of data about the dangers. Impeccable
              reputation and reliability, which is confirmed by the customers' and partners'
              feedback from 1996. The composition of the crews include guards of the 3 category,
              with permission to use lethal weapons.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};
